export default "__VITE_ASSET__C23K7zrd__"